/* eslint-disable @intlify/vue-i18n/no-dynamic-keys -- intentional country-based key lookup */
import { computed, type Ref } from 'vue';
import { useI18n } from 'vue-i18n';

export const REGISTRATION_NUMBER_LABEL_KEYS: Record<string, string> = {
  FR: 'onboarding.businessIdentifier.international.registrationNumber.france',
  ES: 'onboarding.businessIdentifier.international.registrationNumber.spain',
  IT: 'onboarding.businessIdentifier.international.registrationNumber.italy',
  PT: 'onboarding.businessIdentifier.international.registrationNumber.portugal',
  GB: 'onboarding.businessIdentifier.international.registrationNumber.uk',
  NL: 'onboarding.businessIdentifier.international.registrationNumber.netherlands',
  BE: 'onboarding.businessIdentifier.international.registrationNumber.belgium',
  AT: 'onboarding.businessIdentifier.international.registrationNumber.austria',
  CH: 'onboarding.businessIdentifier.international.registrationNumber.switzerland',
};

const DEFAULT_KEY = 'onboarding.businessIdentifier.international.registrationNumber.default';

/**
 * Returns a computed label for the country's business registration number (e.g. "SIREN" for FR).
 */
export function useRegistrationNumberLabel(countryCode: Ref<string> | (() => string)) {
  const { t } = useI18n();

  return computed(() => {
    const code = typeof countryCode === 'function' ? countryCode() : countryCode.value;
    return t(REGISTRATION_NUMBER_LABEL_KEYS[code] || DEFAULT_KEY);
  });
}
